export const geocoderGoogleAddressTypes = {
  LOCALITY: 'locality',
  SUBLOCALITY: 'sublocality',
  ADMINISTRATIVE_AREA_L1: 'administrative_area_level_1',
  ADMINISTRATIVE_AREA_L2: 'administrative_area_level_2'
};
